import posthog from 'posthog-js';

export const captureEvent = (event, data) => {
  if (process.env.BUILD_ENV !== 'production') return;
  posthog.capture(event, data);
};